import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {CardUpdate} from './CardUpdate.jsx';
import './CardList.css';

export const CardList = () => {
  const params = useParams();
  const [token, setToken] = useState('');
  const [cards, setCards] = useState([]);
  const [cardId, setCardId] = useState(-1);
  const [updateCode, setUpdateCode] = useState('');

  const getCards = () => {
    fetch(`/customercards?code=${params.code}`, {
    }).then(response => {
      response.json().then(data => {
        setCards(data.cards);
      });
    });
  };

  useEffect(() => {
    if (params.code) {
      fetch('/csrf', {
      }).then(response => {
          setToken(response.headers.get('X-CSRFToken'));
      });
      setUpdateCode(params.code);
      fetch(`/customercards?code=${params.code}`, {
      }).then(response => {
        response.json().then(data => {
          console.log(data.cards);
          setCards(data.cards);
        });
      });
    }
  }, []);

  const addCard = () => {
    setCardId(0);
    setCards([]);
  };

  const setDefault = async (id) => {
    const response = await fetch('/customercarddefault', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({code: params.code, card_id: id})
    });
    const data = await response.json();
    if (data.ok) {
        getCards();
    }
  };

  const editCard = (id) => {
    setCardId(id);
    setCards([]);
  };

  const deleteCard = async (id) => {
    const response = await fetch('/customercarddelete', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({code: params.code, card_id: id})
    });
    const data = await response.json();
    if (data.ok) {
        getCards();
    }
  };

  const updateComplete = () => {
      setCardId(-1);
      getCards();
  };

  return (
    <div className="cardListContent" >
        <div className="cardListLogo" >
           <img alt="Drops" className="landingBarImg" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
        </div>

        <div className="cardListContentInner" >
            <div className="cardListHeader" >
            <h3>Payment methods</h3>
            </div>

            <div className="cardList">
              { cards.length > 0 &&
              <div className="cardListCards">
              { cards.map((card, key) =>
                <div key={card.id} className="cardListCard">
                    <div className="cardListCardInfo">
                        <div className="cardListCardImg">
                        { card.brand == 'Visa' && <img alt="Visa" src="/images/signup/icon_visa.svg"/>}
                        </div>
                        <div className="cardListCardDetails">
                            <p><span className="cardListCardDetailsBold">{card.brand}</span> ending in {card.last4}</p>
                        </div>
                        <div className="cardListCardExpire">
                        <p>Expires {card.exp_month}/{card.exp_year}</p>
                        </div>
                        { card.enabled &&
                          <div className="cardListCardDefault">
                            (Default)
                          </div>
                        }
                    </div>
                    <div className="cardListCardActions">
                        <div className="cardListCardSetDefault" onClick={() => setDefault(card.id) }>
                        Set Default
                        </div>
                        <div className="cardListCardSeparator1">
                        |
                        </div>

                        <div className="cardListCardEdit" onClick={() => editCard(card.id) }>
                        Edit
                        </div>
                        <div className="cardListCardSeparator2">
                        |
                        </div>
                        <div className="cardListCardDelete" onClick={() => deleteCard(card.id) }>
                        Delete
                        </div>
                    </div>
                </div>
              )}
              </div>
              }
            </div>

            { cardId > -1 ?
               <CardUpdate cardId={cardId} updateComplete={updateComplete} token={token}/>
               :
               <div className="cardListAddCard" onClick={() => addCard() }>
                 <div className="cardListAddCardText">
                 <h5>Add card</h5>
                 </div>
               </div>
            }
        </div>

    </div>
  );
}
